import formModel from './formModel';

const moment = require('moment');

const {
    formField: {
        tamanioVivienda,
        tipoVivienda,
        frecuenciaPago,
        codigosLocalidad,
        descuentoEspecial,
        coberturas: {
            sumaAsegurada,
            selectedCobertura
        },
        vigenciaDesde,
        vigenciaHasta,
        formaDePago,
        infoDePago: {
            numeroCbu,
            marcaTarjeta,
            numeroTarjeta,
        },
        comentariosSolicitud,
        rol,
        dni,
        personaJuridica,
        cuit,
        nombre,
        apellido,
        fechaNacimiento,
        estadoCivil,
        sexo,
        domicilio,
        telefono,
        email,
        situacionIva,
        categoriaMonotributo,
        actividadPrincipal,
        lugarNacimiento,
        detalleEquipoElectronico: {
            sumaAseguradaElectronico,
            descripcionElectronico,
            codigoElectronico,
            codigoGrupoElectronico
        },
        detalleBicicletas: {
            sumaAseguradaBicicletas,
            descripcionBicicletas,
            codigoBicicletas,
            codigoGrupoBicicletas
        },
        detalleMonopatines: {
            sumaAseguradaMonopatines,
            descripcionMonopatines,
            codigoMonopatines,
            codigoGrupoMonopatines
        },
    }
} = formModel;

const coberturasInitialValues =
    {
        1: {[sumaAsegurada.name]: 0},
        2: {[sumaAsegurada.name]: 0},
        5: {[sumaAsegurada.name]: 0},
        17: {[sumaAsegurada.name]: 0},
        22: {[sumaAsegurada.name]: 0},
        35: {[sumaAsegurada.name]: 0},
    };

const coberturasAdicionalesInitialValues =
    {
        26: {
            [sumaAsegurada.name]: 0,
            [selectedCobertura.name]: false,
        },
        36: {
            [sumaAsegurada.name]: 0,
            [selectedCobertura.name]: false,
        },
        37: {
            [sumaAsegurada.name]: 0,
            [selectedCobertura.name]: false,
        },
        48: {
            [sumaAsegurada.name]: 0,
            [selectedCobertura.name]: false,
        },
        49: {
            [sumaAsegurada.name]: 0,
            [selectedCobertura.name]: false,
        },
    };

export default {
    [tamanioVivienda.name]: "Mediana",
    [tipoVivienda.name]: "",
    [codigosLocalidad.name]: "",
    [frecuenciaPago.name]: '5',
    [descuentoEspecial.name]: 20,
    coberturas: coberturasInitialValues,
    coberturasAdicionales: coberturasAdicionalesInitialValues,
    [vigenciaDesde.name]: moment().format('YYYY-MM-DD'),
    [vigenciaHasta.name]: moment().add(1, "Y").format("YYYY-MM-DD"),
    [formaDePago.name]: '4',
    infoDePago: {
        [numeroCbu.name]: '',
        [marcaTarjeta.name]: '',
        [numeroTarjeta.name]: '',
    },
    [comentariosSolicitud.name]: '',
    [rol.name]: '2',
    [personaJuridica.name]: '0',
    [dni.name]: '',
    [cuit.name]: '',
    [nombre.name]: '',
    [apellido.name]: '',
    [fechaNacimiento.name]: '',
    [estadoCivil.name]: '2',
    [sexo.name]: '',
    [domicilio.name]: '',
    [codigosLocalidad.name]: '',
    [telefono.name]: '',
    [email.name]: '',
    [situacionIva.name]: '4',
    [categoriaMonotributo.name]: '1',
    [actividadPrincipal.name]: '10001',
    [lugarNacimiento.name]: 'Cordoba',
    detalleEquipoElectronico: [
        {
            [descripcionElectronico.name]: "",
            [sumaAseguradaElectronico.name]: "",
            [codigoElectronico.name]: 201,
            [codigoGrupoElectronico.name]: 34,
        },
    ],
    detalleBicicletas: [
        {
            [descripcionBicicletas.name]: "",
            [sumaAseguradaBicicletas.name]: "",
            [codigoBicicletas.name]: 209,
            [codigoGrupoBicicletas.name]: 31,
        },
    ],
    detalleMonopatines: [
        {
            [descripcionMonopatines.name]: "",
            [sumaAseguradaMonopatines.name]: "",
            [codigoMonopatines.name]: 210,
            [codigoGrupoMonopatines.name]: 31,
        },
    ],
};
